import { z } from 'zod';
import { FocusArea } from 'libs/end-to-end/src/focus-area';

export const KeyTakeawayHighlightType = z
  .enum(['representation', 'parity', 'disparity', 'optimization', 'bias'])
  .describe('KeyTakeawayHighlightType');

export type KeyTakeawayHighlightType = z.infer<typeof KeyTakeawayHighlightType>;

export const KeyTakeawayType = z.enum(['achievements', 'risks']);

export type KeyTakeawayType = z.infer<typeof KeyTakeawayType>;

export const KeyTakeawayDifferenceType = z.enum(['better', 'worse', 'same']);

export type KeyTakeawayDifferenceType = z.infer<
  typeof KeyTakeawayDifferenceType
>;

export const KeyTakeawaySummaryItem = z.object({
  focus_area: FocusArea,
  dimension: z.string(),
  privileged_group: z.string(),
  underprivileged_group: z.string(),
  highlight_type: KeyTakeawayHighlightType,
  difference: KeyTakeawayDifferenceType,
  value: z.number(),
  priority: z.number().optional(),
  takeaway_type: KeyTakeawayType,
});

export type KeyTakeawaySummaryItem = z.infer<typeof KeyTakeawaySummaryItem>;

export const KeyTakeawaysSummary = z.object({
  achievements: z.array(KeyTakeawaySummaryItem).optional(),
  risks: z.array(KeyTakeawaySummaryItem).optional(),
});

export type KeyTakeawaysSummary = z.infer<typeof KeyTakeawaysSummary>;
